// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2HEvQ","noInteraction":"EventWrapper_noInteraction__3sGVF","pointerPassthrough":"EventWrapper_pointerPassthrough__3p53O"};